"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-check-in-circle.tsx
var CheckInCircle = function CheckInCircle(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_416_9906)"
  }, (0, _preact.h)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_416_9906"
  }, (0, _preact.h)("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
};

var _default = CheckInCircle;
exports.default = _default;